/**
 * Groupe de filtres exclusif (« un seul choix ») rendu en boutons `aria-pressed`.
 *
 * Pourquoi des boutons et non des `<input type="radio">` : la cible tactile doit rester ≥ 44 × 44 px
 * sur téléphone (§10, WCAG 2.5.5), et un bouton porte déjà toute la surface cliquable du thème.
 * `aria-pressed` conserve l'information d'état pour les lecteurs d'écran, et le groupe est encadré
 * par un `<fieldset>/<legend>` : le nom du filtre est annoncé avec chaque option.
 *
 * Les libellés arrivent **déjà traduits** : ce composant ne connaît aucun texte (DECISIONS §9.3).
 * Les valeurs sont des chaînes : les listes fermées (éléments, raretés, possession) sont
 * construites par l'écran qui les affiche, jamais ouvertes à une saisie libre.
 */
export interface OptionFiltre {
  readonly valeur: string;
  readonly libelle: string;
}

export interface ProprietesGroupeFiltre {
  /** Identifiant technique du filtre (`element`, `rarete`, `possession`), exposé en `data-`. */
  readonly id: string;
  readonly legende: string;
  readonly options: readonly OptionFiltre[];
  readonly valeur: string;
  readonly surChangement: (valeur: string) => void;
}

export function GroupeFiltre({
  id,
  legende,
  options,
  valeur,
  surChangement,
}: ProprietesGroupeFiltre) {
  return (
    <fieldset className="filtre" data-filtre={id}>
      <legend className="filtre__legende">{legende}</legend>
      <div className="filtre__options">
        {options.map((option) => (
          <button
            key={option.valeur}
            type="button"
            className="filtre__bouton"
            data-valeur={option.valeur}
            aria-pressed={option.valeur === valeur}
            onClick={() => {
              surChangement(option.valeur);
            }}
          >
            {option.libelle}
          </button>
        ))}
      </div>
    </fieldset>
  );
}
